import { compose } from 'redux'
import LandingCompanyInfo from './components'
import { withServices } from '../../services/ServiceContext'

export default compose(
  withServices(resolve => ({
    Piwik: resolve('Piwik')
  }))
)(LandingCompanyInfo)
